import React from 'react';
import { Box, Container, Divider } from '@hover/blueprint';
import {
  Layout,
  StillHaveQuestions,
  HelpFulLinksTabletDesktop,
  ContactUs,
  BackToTopButton,
} from '../../v2/components/common';
import {
  Description,
  Hero,
  SecurityAndPrivacy,
  FAQ,
} from '../../v2/components/trust-center';

const TrustCenter: React.FC = () => (
  <Layout
    title="Trust center"
    navbarBackgroundColor="primary.100"
    isNavbarWhite={false}
    titleColor="neutral.900"
  >
    <Hero />
    <Container
      maxW="100%"
      position="relative"
      overflow="visible"
      px={500}
      centerContent
    >
      <Box w="100%" maxW="1200px">
        <Box
          h="418px"
          w="276px"
          zIndex={1}
          d={{ base: 'none', tablet: 'block' }}
          position="sticky"
          top="20vh"
          mb="82px"
        >
          <HelpFulLinksTabletDesktop />
        </Box>
        <Box
          maxW="780px"
          w="100%"
          ml={{ base: 0, tablet: '134px' }}
          flexDir="column"
          mb={1000}
        >
          <Description />
          <SecurityAndPrivacy />
          <FAQ />
          <Box d={{ base: 'flex', tablet: 'none' }} flexDir="column" mt={700}>
            <Divider
              borderColor="neutral.300"
              mt={0}
              mb={200}
              borderWidth="1px"
              borderTopWidth={0}
            />
            <ContactUs />
            <Divider
              borderColor="neutral.300"
              mt={200}
              mb={0}
              borderWidth="1px"
              borderTopWidth={0}
            />
          </Box>
        </Box>
      </Box>
    </Container>
    <StillHaveQuestions />
    <BackToTopButton />
  </Layout>
);

export default TrustCenter;
